export class PersonDelegation {

  id!: number;
  assignee!: string;
  delegate!: string;
  delegateDisplay!: string;
  startTime!: Date;
  endTime!: Date;

}
